module.exports = fox._r("htmlplayer/fonts/acplayer.ttf?9g9mys", __webpack_public_path__ + "_/_/_/_/common-components/htmlplayer/fonts/3uQdS7F.ttf");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/common-components/htmlplayer/fonts/acplayer.ttf?9g9mys
// module id = 563
// module chunks = 4